export default "__VITE_ASSET__BiseYCsk__";